<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="headline font-weight-bold mb-4">
          PopUp de Terminos, Condiciones y Politicas de Privacidad
        </div>
        <v-breadcrumbs
          divider=">"
          :items="breadcrumbItems"
          class="pa-0"
        ></v-breadcrumbs>
      </v-col>
    </v-row>
    <v-card flat min-height="100vh" color="grey lighten-3">
      <v-card-text style="overflow-y: auto; height: calc(100vh - 64px)">
        <v-container class="pa-5">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-btn
                  color="primary"
                  block
                  @click="togglePopUpDialogConfig(true)"
                >
                  <v-icon left> add </v-icon>
                  agregar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-data-table :headers="headers" :items="allTCPP" class="elevation-1">
            <template v-slot:top>
              <v-dialog v-model="dialogDelete" max-width="650px">
                <v-card>
                  <v-card-title class="text-h5">
                    Esta seguro que desa eliminar esta configuración?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogDelete = false"
                      >{{ $t("actions.cancel") }}</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="deleteItemConfirm()"
                      >OK</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:item.title="{ item }">
              <tr align="center">
                <td class="truncateTitle">{{ item.title }}</td>
              </tr>
            </template>
            <template v-slot:item.is_active="{ item }">
              <tr v-if="item.is_active" style="color: green" align="center">
                <td>enabled</td>
              </tr>
              <tr v-else style="color: red" align="center">
                <td>disabled</td>
              </tr>
            </template>
            <template v-slot:item.language="{ item }">
              <tr align="center">
                <td class="truncateTitle">{{ item.language }}</td>
              </tr>
            </template>
            <template v-slot:item.actions="{ item }">
              <tr>
                <v-btn icon>
                  <v-icon @click="editItem(item)" color="primary">tune</v-icon>
                </v-btn>
                <v-btn icon v-if="!item.is_active">
                  <v-icon @click="deleteItem(item)" color="red">delete</v-icon>
                </v-btn>
              </tr>
            </template>
            <template v-slot:item.enable="{ item }">
              <tr align="center">
                <v-btn
                  small
                  v-if="item.is_active"
                  block
                  color="primary"
                  @click="disable(item)"
                >
                  {{ $t("actions.disable") }}
                </v-btn>
                <v-btn small v-else block color="primary" @click="enable(item)">
                  {{ $t("actions.enable") }}
                </v-btn>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>

    <!--------------------------------------->
    <!-----------  AGREGAR POP UP ----------->
    <!--------------------------------------->
    <v-dialog
      v-model="isPopUpDialogConfigOpen"
      persistent
      :overlay="true"
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="pa-6">
          Configurar popup <v-spacer></v-spacer>
          <v-menu
            offset-y
            left
            nudge-bottom="10px"
            min-width="300px"
            max-width="300px"
            style="z-index: 20"
          >
            <template v-slot:activator="{ on }">
              <v-btn ref="button-menu-tags" v-on="on" text>
                <v-icon>code</v-icon>
              </v-btn>
            </template>
            <v-card ref="content-menu-tags">
              <v-card-title>
                {{ $t("templates.create.tags_merge") }}
              </v-card-title>
              <v-divider />
              <v-card-text
                v-if="!mergeTags.length"
                style="max-height: 400px; overflow-y: auto"
                class="pa-4"
              >
                <v-row dense>
                  <v-col>
                    <v-img
                      :src="require('@/assets/svg/box_empty.svg')"
                      height="150"
                      max-height="150px"
                      aspect-ratio="1"
                      contain
                    />
                    <div class="text-center">
                      {{ $t("common.no_results_found") }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-list v-else dense max-height="250px" class="overflow-y-auto">
                <v-list-item
                  v-for="(item, index) in mergeTags"
                  :key="index"
                  @click="copyText(item.value)"
                >
                  <v-icon class="mr-3"> bookmark </v-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text" />
                    <v-list-item-subtitle v-text="item.value" />
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-card-title>
        <v-card-text class="pa-8">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="TCPP.language"
                  :items="avaliableLanguages"
                  item-text="name"
                  item-value="code"
                  :label="$t('profile.profile.language')"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="TCPP.title"
                  label="Título"
                  :rules="titleRules"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="TCPP.description"
                  label="Descripcion Owner"
                  :rules="descriptionRules"
                  no-resize
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="TCPP.not_admin_description"
                  label="Descripcion para usuarios not Owners"
                  :rules="descriptionRules"
                  no-resize
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="TCPP.terms_and_conditions_checkbox"
                  label="Texto del checkbox de Terminos y condiciones"
                  :rules="termsAndConditionsRules"
                  no-resize
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="TCPP.privacy_policy_checkbox"
                  label="Texto del checkbox de Politica de Privacidad"
                  :rules="privacyPolicyRules"
                  no-resize
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="TCPP.terms_and_conditions_link"
                  label="Enlace de Terminos y Condiciones"
                  hint="Ejemplo: https://my.afrus.app/new-release"
                  :rules="termsAndConditionsLinkRules"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="TCPP.privacy_policy_link"
                  label="Enlace de Politica de Privacidad"
                  hint="Ejemplo: https://my.afrus.app/new-release"
                  :rules="PrivacyPolicyLinkRules"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="TCPP.button_text"
                  label="Texto del boton del popup"
                  :rules="buttonTextRules"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="selectedOrganizations"
                  :items="organizationNames"
                  label="Selecciona las organizaciones"
                  chips
                  multiple
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggle">
                      <v-list-item-action>
                        <v-icon>
                          {{ selectIcon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title> Select All </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            color="primary"
            text
            width="100px"
            @click="closeDialogConfig()"
          >
            {{ $t("actions.cancel") }}
          </v-btn>
          <v-btn color="primary" width="100px" @click="save()">
            {{ $t("actions.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Vue from "vue";
import { organizationService } from "@/services/organization.service";

export default {
  name: "TermsPrivacy",
  components: {},
  data() {
    return {
      titleRules: [v => !!v || "Title is required"],
      termsAndConditionsRules: [
        v => !!v || "Terminos y Condiciones is required"
      ],
      descriptionRules: [v => !!v || "Descripcion is required"],
      privacyPolicyRules: [v => !!v || "Politica de Privacidad is required"],
      termsAndConditionsLinkRules: [
        v => !!v || "Enlace de Terminos y Condiciones is required"
      ],
      PrivacyPolicyLinkRules: [
        v => !!v || "Enlace de Politica de Privacidad is required"
      ],
      buttonTextRules: [v => !!v || "Texto del boton del popup is required"],
      breadcrumbItems: [
        {
          text: "Comunicaciones",
          disabled: false
        },
        {
          text:
            "Configurar Pop Up de Terminos, Condiciones y Politicas de Privacidad",
          disabled: true,
          href: ""
        }
      ],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id"
        },
        {
          text: "Titulo",
          align: "start",
          sortable: false,
          value: "title"
        },
        { text: "status", value: "is_active", sortable: false },
        { text: "Fecha", value: "created_at" },
        { text: "Lenguaje", value: "language", sortable: false },
        { text: "Acciones", value: "actions", sortable: false },
        { text: "Habilitar/Deshabilitar", value: "enable", sortable: false }
      ],
      TCPP: {
        title: null,
        description: null,
        not_admin_description: null,
        terms_and_conditions_checkbox: null,
        privacy_policy_checkbox: null,
        terms_and_conditions_link: null,
        privacy_policy_link: null,
        button_text: null,
        language: null
      },
      organizations: [],
      organizationNames: [],
      selectedOrganizations: [],
      dialogDelete: false,
      selectedTCPP: null,
      isEdit: false,
      mergeTags: [
        {
          text: "Owner",
          value: "{{Owner}}"
        },
        {
          text: "Owner Email",
          value: "{{OwnerEmail}}"
        }
      ],
      copyTextField: ""
    };
  },
  async created() {
    this.getTCPPs();
    this.getAllOrganizations();
  },
  computed: {
    ...mapState({
      languages: ({ auth: { locales } }) => locales
    }),
    ...mapGetters({
      isPopUpDialogConfigOpen:
        "termsConditionsAndPrivacyPolicies/isPopUpDialogConfigOpen",
      allTCPP: "termsConditionsAndPrivacyPolicies/allTCPP"
    }),
    avaliableLanguages() {
      return this.languages.map(e => {
        return {
          ...e
        };
      });
    },
    allOrg() {
      return this.selectedOrganizations.length === this.organizations.length;
    },
    someOrg() {
      return this.selectedOrganizations.length > 0 && !this.allOrg;
    },
    selectIcon() {
      if (this.allOrg) return "close";
      if (this.someOrg) return "add";
      return "add";
    }
  },

  methods: {
    ...mapActions({
      togglePopUpDialogConfig:
        "termsConditionsAndPrivacyPolicies/togglePopUpDialogConfig",
      storeTCPP: "termsConditionsAndPrivacyPolicies/storeTCPP",
      updateTCPP: "termsConditionsAndPrivacyPolicies/updateTCPP",
      getAllTCPP: "termsConditionsAndPrivacyPolicies/getAllTCPP",
      deleteTCPP: "termsConditionsAndPrivacyPolicies/deleteTCPP",
      enableTCPP: "termsConditionsAndPrivacyPolicies/enableTCPP",
      disableTCPP: "termsConditionsAndPrivacyPolicies/disableTCPP"
    }),
    async getTCPPs() {
      this.getAllTCPP();
    },
    async save() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        let payload = this.TCPP;

        let orgs = [];
        for (let i = 0; i < this.organizations.length; i++) {
          for (let j = 0; j < this.selectedOrganizations.length; j++) {
            if (this.organizations[i].name === this.selectedOrganizations[j]) {
              orgs.push(this.organizations[i]);
            }
          }
        }

        payload.organizations = orgs;

        const action = this.isEdit
          ? this.updateTCPP(payload)
          : this.storeTCPP(payload);
        this.closeDialogConfig();
      }
    },
    closeDialogConfig() {
      this.TCPP = {
        title: null,
        description: null,
        not_admin_description: null,
        terms_and_conditions_checkbox: null,
        privacy_policy_checkbox: null,
        terms_and_conditions_link: null,
        privacy_policy_link: null,
        button_text: null,
        language: null
      };
      this.isEdit = false;
      this.$refs.form.reset();
      this.togglePopUpDialogConfig(false);
    },
    deleteItem(item) {
      this.selectedTCPP = item;
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      const id = this.selectedTCPP.id;
      this.deleteTCPP(id);
      this.dialogDelete = false;
    },
    editItem(item) {
      this.TCPP = Object.assign({}, item);
      if (item.organizations) {
        this.selectedOrganizations = item.organizations.organizations.map(
          org => org.name
        );
      }
      this.isEdit = true;
      this.togglePopUpDialogConfig(true);
    },
    enable(item) {
      this.selectedTCPP = item;
      this.enableTCPP(item);
    },
    disable(item) {
      this.selectedTCPP = item;
      this.disableTCPP(item.id);
    },
    async copyText(text) {
      navigator.clipboard.writeText(text);
      Vue.noty.success("Texto copiado con éxito");
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allOrg) {
          this.selectedOrganizations = [];
        } else {
          this.selectedOrganizations = this.organizationNames.slice();
        }
      });
    },
    async getAllOrganizations() {
      try {
        const response = await organizationService.getAllOrganizations();

        const data = response.data;
        this.organizationNames = data.map(org => {
          return org.name;
        });
        this.organizations = response.data;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
